import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  ShoppingCart,
  Package,
  LayoutDashboard,
  Table2,
  Menu
} from 'lucide-react';
import { cn } from '@/lib/utils';

const mobileNavItems = [
  {
    path: '/dashboard',
    label: 'Inicio',
    icon: LayoutDashboard,
    testId: 'mobile-nav-dashboard'
  },
  {
    path: '/pos',
    label: 'POS',
    icon: ShoppingCart,
    testId: 'mobile-nav-pos'
  },
  {
    path: '/inventory',
    label: 'Stock',
    icon: Package,
    testId: 'mobile-nav-inventory'
  },
  {
    path: '/reports',
    label: 'Más',
    icon: Menu,
    testId: 'mobile-nav-more'
  }
];

export const MobileNav: React.FC = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg md:hidden z-50">
      <div className="grid grid-cols-4 h-16">
        {mobileNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                cn(
                  'flex flex-col items-center justify-center px-2 py-2 text-xs font-medium transition-colors',
                  'hover:bg-gray-50 active:bg-gray-100',
                  isActive
                    ? 'text-macartur-primary bg-orange-50'
                    : 'text-gray-600'
                )
              }
              data-testid={item.testId}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-[10px] leading-none">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};